import { useRef, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { useLang } from "../context/LangContext";
import { api } from "../lib/api";
import { Seo } from "../components/Seo";
import NeuralBackground from "../components/NeuralBackground";
import CaptchaField from "../components/CaptchaField";

const inputCls = "w-full bg-white border border-slate-300 rounded-md px-4 py-3 text-sm text-[#0B1220] placeholder:text-slate-400 focus:border-[#5698C7] focus:outline-none focus:ring-1 focus:ring-[#5698C7] transition-colors duration-200 shadow-sm";

export default function Contacto() {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const captchaRef = useRef(null);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!captchaToken) { toast.error("Completa la verificación reCAPTCHA"); return; }    setSending(true);
    try {
      await api.post("/public/contact", { ...form, recaptcha_token: captchaToken });
      toast.success(t("contact_ok"));
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Error al enviar el mensaje");
    } finally {
      setSending(false);
      setCaptchaToken(""); captchaRef.current?.reset();
    }
  };

  return (
    <div data-testid="contact-page">
      <Seo page="contacto" />
      <section className="relative border-b border-slate-200 overflow-hidden">
        <NeuralBackground />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-24">
          <span className="font-mono-tech text-xs tracking-[0.3em] text-[#5698C7]">CONTACTO</span>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4" data-testid="contact-title">{t("contact_title")}</h1>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-20">
        <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <input required value={form.name} onChange={set("name")} placeholder={t("contact_name")} className={inputCls} data-testid="contact-name-input" />
            <input required type="email" value={form.email} onChange={set("email")} placeholder={t("contact_email")} className={inputCls} data-testid="contact-email-input" />
          </div>
          <input value={form.subject} onChange={set("subject")} placeholder={t("contact_subject")} className={inputCls} data-testid="contact-subject-input" />
          <textarea required rows={6} value={form.message} onChange={set("message")} placeholder={t("contact_message")} className={inputCls} data-testid="contact-message-input" />
          <CaptchaField captchaRef={captchaRef} onToken={setCaptchaToken} />
          <button type="submit" disabled={sending} data-testid="contact-submit-btn"
            className="inline-flex items-center gap-2 bg-[#5698C7] text-white font-mono-tech text-xs tracking-widest font-medium px-8 py-3 rounded-md hover:bg-[#4587B8] transition-colors duration-200 disabled:opacity-50">
            <Send size={14} /> {t("contact_send").toUpperCase()}
          </button>
        </form>
      </section>
    </div>
  );
}
